import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './components/main/not-found/not-found.component';

import { MatIconModule } from '@angular/material/icon';
import { ErrorDialogComponent } from './components/dialog/error-dialog/error-dialog.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [NotFoundComponent, ErrorDialogComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class ErrorModule { }
